import "core-js/modules/es.array.push.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9932ea30"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
const _hoisted_2 = {
  class: "custom-btn img-download"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "反馈", -1));
import myLoginDialog from './myLoginDialog.vue';
import mobileHeader from './mobileHeader.vue';
import { ref, reactive, onMounted } from 'vue';
import { myMixin } from '../mixin.js';
import { useRouter } from 'vue-router';
export default {
  __name: 'myHeader',
  props: {
    type: String,
    columns: Array,
    isDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['doShowAddCal'],
  setup(__props, {
    emit: $emit
  }) {
    const props = __props;
    const {
      successMsgBox,
      errorMsgBox,
      apiAll,
      withLoading,
      getNewFiles,
      getData,
      handleLabelWidth,
      formDataApi,
      theme
    } = myMixin();
    const logoImg = require('../assets/logo.png');
    const router = useRouter();
    const showDialog = ref(false);
    const showFeedback = ref(false);
    const feedBack = ref('');
    const user = reactive({
      obj: {}
    });
    onMounted(() => {
      if (window.sessionStorage.getItem('huatu_user')) {
        user.obk = JSON.parse(window.sessionStorage.getItem('huatu_user'));
      }
    });
    function doShowFeedback() {
      showFeedback.value = true;
    }
    function gotoCreateImg() {
      router.push('/createImg');
    }
    function gotoCropImg() {
      router.push('/cropImg');
    }
    function gotoCompressImg() {
      router.push('/compressImg');
    }
    function gotoChangeImg() {
      router.push('/changeImg');
    }
    function gotoImgToBase64() {
      router.push('/imgToBase64');
    }
    function gotoQrcode() {
      router.push('/qrCode');
    }
    function doShowAddCal() {
      $emit('doShowAddCal');
    }
    async function doSubmit(model) {
      let method = 'registLoginH';
      // const data = await myFetch('post', {
      // 	customBaseURL: method,
      // 	data: model
      // });

      const data = await withLoading(apiAll(model, method));
      if (data.code && data.code <= 0) {
        errorMsgBox(data.message);
      } else {
        if (data.token) {
          window.sessionStorage.setItem('huatu_token', data.token);
          window.sessionStorage.setItem('huatu_user', JSON.stringify(model));
          showDialog.value = false;
          user.obj = model;
        } else {}
      }
    }
    async function saveFeedback() {
      if (!feedBack.value) {
        errorMsgBox('还未输入内容哦！');
        return false;
      }
      //编辑
      const res = await withLoading(apiAll({
        content: feedBack.value
      }, '/saveFeedback'));
      if (res.code && res.code <= 0) {
        errorMsgBox(res.message);
      } else {
        successMsgBox('提交成功，感谢您的建议！');
        showFeedback.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_Edit = _resolveComponent("Edit");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_row, {
        class: "my-header"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 17,
          style: {
            "display": "flex"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            onClick: gotoCreateImg,
            class: "left-title",
            style: {
              "margin-left": "10px"
            }
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== 'createImg' ? 'light' : ''])
          }, "图片生成", 2)]), _createElementVNode("div", {
            onClick: gotoCropImg,
            class: "left-title"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== 'crop' ? 'light' : ''])
          }, "图片裁剪", 2)]), _createElementVNode("div", {
            onClick: gotoQrcode,
            class: "left-title"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== 'qrCode' ? 'light' : ''])
          }, "生成二维码", 2)]), _createElementVNode("div", {
            onClick: gotoChangeImg,
            class: "left-title"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== '图片转换' ? 'light' : ''])
          }, "图片转换", 2)]), _createElementVNode("div", {
            onClick: gotoImgToBase64,
            class: "left-title"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== 'base64' ? 'light' : ''])
          }, "图片转base64", 2)]), _createElementVNode("div", {
            onClick: gotoCompressImg,
            class: "left-title"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["custom-btn btn-14", __props.type !== '图片压缩' ? 'light' : ''])
          }, "图片压缩", 2)])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 7,
          style: {
            "text-align": "right"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [user.obj && user.obj.user_name ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(user.obj.user_name), 1)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: _cache[0] || (_cache[0] = $event => showDialog.value = true)
          }, "登录/注册"))]), _createElementVNode("div", {
            class: "custom-btn light",
            onClick: doShowFeedback
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Edit)]),
            _: 1
          }), _hoisted_4])])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(myLoginDialog, {
        showDialog: showDialog.value,
        onCloseDialog: _cache[1] || (_cache[1] = $event => showDialog.value = false),
        onDoSubmit: doSubmit
      }, null, 8, ["showDialog"]), _createVNode(_component_a_modal, {
        width: "30%",
        open: showFeedback.value,
        "onUpdate:open": _cache[3] || (_cache[3] = $event => showFeedback.value = $event),
        title: "反馈建议",
        footer: null
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "textarea",
          rows: 5,
          modelValue: feedBack.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => feedBack.value = $event),
          maxlength: 200,
          "show-word-limit": "",
          placeholder: "您有什么好建议，或者有什么bug呢，欢饮指出！"
        }, null, 8, ["modelValue"]), _createElementVNode("div", {
          class: "custom-btn",
          type: "primary",
          style: {
            "margin-top": "20px"
          },
          onClick: saveFeedback
        }, "提交")]),
        _: 1
      }, 8, ["open"]), _createVNode(mobileHeader, {
        onGotoCompressImg: gotoCompressImg
      })])]);
    };
  }
};